import React, { FC } from 'react';

export interface Props {
  src: string | undefined;
  alt: string | undefined;
}

const EmbeddedPhotoField: FC<Props> = ({ src, alt }: Props) => {
  return (
    <div>
      {src && src.length > 0 && <img className="w-100" src={src} alt={alt} data-testid="image-test" />}
      {(!src || src.length == 0) && <span>-</span>}
    </div>
  );
};

export default EmbeddedPhotoField;
